<template>
  <div id="chart" style="margin-left: -10px">
    <apexchart
      height="100%"
      width="100%"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  props: ["dados", "categorias", "cores", "qtdeMeses"],

  data() {
    return {
      series: [],
      ocorrenciasItem: [],
      categories: [],
      colors: [],
      meses: [
        "Jan",
        "Fev",
        "Mar",
        "Abr",
        "Mai",
        "Jun",
        "Jul",
        "Ago",
        "Set",
        "Out",
        "Nov",
        "Dez"
      ]
    };
  },

  computed: {
    options() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: false,
            offsetX: 10,
            offsetY: 20,
          },
          stackType: '100%'
        },
        grid: {
          show: true,
          position: "back",
          yaxis: {
            lines: {
              show: true,
            },
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 10,
          },
        },
        noData: {
          text: "Carregando... aguarde",
          align: "center",
          verticalAlign: "middle",
          style: {
            fontSize: "14px"
          }
        },
        dataLabels: {
          enabled: false,
          style: {
            colors: ["#FFF"],
            fontWeight: "",
            fontSize: "11px",
          },
          background: {
            enabled: false
          },
        },
        colors: this.colors,
        xaxis: {
          categories: this.categories,
        },
        yaxis: {
          show: true,
          forceNiceScale: true,
          title: {
            style: {
              color: "#000",
              fontSize: "12px",
              fontWeight: 600,
              cssClass: "apexcharts-yaxis-title"
            }
          },
          labels: {
            formatter: function(n) {
              var ranges = [
                { divider: 1e6, suffix: "M" },
                { divider: 1e3, suffix: "k" },
                { divider: 1, suffix: " " }
              ];

              for (var i = 0; i < ranges.length; i++) {
                if (n >= ranges[i].divider) {
                  if (ranges[i].divider === 1) {
                    return (
                      (Math.round(n) / ranges[i].divider).toString() + ranges[i].suffix
                    );
                  } else {
                    return (
                      (Math.round(n) / ranges[i].divider)
                        .toString() + ranges[i].suffix
                    );
                  }
                }
              }
              return 0;
            }
          }
        },
        legend: {
          position: 'top',
          offsetY: 10,
          markers: {
            width: 13,
            height: 13,
            radius: 1
          },
          itemMargin: {
            horizontal: 5,
            vertical: 0
          }
        },
        tooltip: {
          enabled: true,
          shared: true,
          intersect: false,
          x: {
            show: true,
            formatter: valor => {
              const dt = valor.split("-");
              if (dt[1]) return `${this.meses[parseInt(dt[1]) - 1]} de ${dt[0]}`;

              return valor
            }
          },
          y: {
            formatter: function(val) {
              return new Intl.NumberFormat("pt-BR", {
                style: "decimal",
                maxDigits: 4
              }).format(val);
            }
          }
        },
      };
    },
  },

  watch: {
    dados() {
      this.montaGrafico();
    }
  },

  methods: {
    montaGrafico() {
      let arrays = [];
      let resetColor = true;

      Object.keys(this.dados).forEach((key) => {

        let linha = [];

        Object.values(this.dados[key]).forEach((value) => {
          linha.push(value);
        });

        let arrayKey = key.split("_");
        arrayKey[0] = arrayKey[0].charAt(0).toUpperCase() + arrayKey[0].substr(1);

        arrays.push({
          name: arrayKey.join(' '),
          data: linha,
        });

        if (resetColor) {
          this.colors = [];
          resetColor = false;
        }
        this.colors.push(this.cores[key]);
      });

      this.categories = [];

      Object.keys(this.categorias).forEach(el => {
        let value = el.split('-');
        let mes = Number(value[1]);
        let ano = Number(value[0]);
        let newValue = (this.meses[mes - 1]) + ' de ' + ano;
        this.categories.push(newValue);
      });

      this.series = arrays;
    }
  }
};
</script>
